import { render, staticRenderFns } from "./ProductCategoryCommonFilters.vue?vue&type=template&id=d4bc7c7e&"
import script from "./ProductCategoryCommonFilters.vue?vue&type=script&lang=js&"
export * from "./ProductCategoryCommonFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports